export * as entityMapper from '@wix/auto_sdk_multilingual_entity-mapper/schemas';
export * as locales from '@wix/auto_sdk_multilingual_locales/schemas';
export * as translationPublishedContents from '@wix/auto_sdk_multilingual_translation-published-contents/schemas';
export * as translationCredits from '@wix/auto_sdk_multilingual_translation-credits/schemas';
export * as machineTranslation from '@wix/auto_sdk_multilingual_machine-translation/schemas';
export * as localeSettings from '@wix/auto_sdk_multilingual_locale-settings/schemas';
export * as siteTranslator from '@wix/auto_sdk_multilingual_site-translator/schemas';
export * as translationContents from '@wix/auto_sdk_multilingual_translation-contents/schemas';
export * as translationSchemas from '@wix/auto_sdk_multilingual_translation-schemas/schemas';
